var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/about"}},[_vm._v("About")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/works"}},[_vm._v("Works")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/contact"}},[_vm._v("Contact")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7694347a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/HeadComp.vue
// module id = null
// module chunks = 